export function isInside(outer, inner) {
    return outer.left <= inner.left &&
        inner.left <= outer.right &&
        outer.left <= inner.right &&
        inner.right <= outer.right &&
        outer.top <= inner.top &&
        inner.top <= outer.bottom &&
        outer.top <= inner.bottom &&
        inner.bottom <= outer.bottom;
}
//# sourceMappingURL=calendarUtils.provider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-calendar/dist/esm/src/providers/calendarUtils.provider.js
// module id = 675
// module chunks = 4